import React, {useState, useEffect, useRef} from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import * as StyleFunctions from '../utilities/StyleFunctions';
import * as CoreFns from '../utilities/CoreFns';
import * as SharedAcross from '../utilities/SharedAcross';
import { Icon } from '@iconify/react';

/* global BigInt */

function Dropdown(props) {

	var options = props.options;
	var value = props.value;
	var onChange = props.onChange;
	var thisItemRef = props.thisItemRef;
	var onClick = props.onClick;
	var style = props.style;
	var addClassNames = props.addClassNames;
	var disabled = props.disabled;

  const [isOpen, setOpen] = useState(false);
  
  function toggleDropdown(e){
  	if (!disabled){
	  	setOpen(!isOpen);
  	}else{
  		setOpen(false);
  	}
  	onClick(e);
  	e.stopPropagation();
  }

 	 function onChangeX(item){
 	 	return function(e){
	  	onChange(item);
	  	setOpen(false);
			e.stopPropagation();
 	 	}
 	 }

	// useEffect(() => {
	//   	onChange(value);
	// }, [value]);


  var addStyle= {width:'100%', boxShadow:'0 10px 25px rgba(0,0,0,.1)'};
  var darkLight = 'Darker';
  if (style.shadeWhenHover === 'Light'){
  	darkLight = 'Lighter';
  }

  var bodyStyle = {padding:'10px'};
  var textStyle = {};
  if (style.textAlignment === 'text-left'){
  	bodyStyle.textAlign = 'left';
  }else if (style.textAlignment === 'text-justify'){
  	bodyStyle.textAlign = 'justify';
  }else if (style.textAlignment === 'text-center'){
  	textStyle = {marginLeft:'auto', marginRight: 'auto'};
  	bodyStyle.textAlign = 'center';
  }else if (style.textAlignment === 'text-right'){
  	textStyle = {marginLeft:'auto', paddingRight: '15px'};
  	bodyStyle.textAlign = 'right';
  }


  return (
    <div ref={thisItemRef} className={addClassNames}>
			<div style={{...addStyle, ...style}} className={`mainDropdown ${isOpen && 'open'}`}>
      <div className='mainDropdownHeader' onClick={toggleDropdown} style = {{padding:'10px'}}>
        <div className='mainDropdownText' style={textStyle} >{value}</div>
        <div className={`mainDropdownIcon ${isOpen && "open"}`}><Icon icon='eva:arrow-ios-forward-fill'/></div>
      </div>
      <div className={`mainDropdownBody ${isOpen && 'open'}`} style={{padding:'5px', backgroundColor:style.backgroundColor2}}>
        {options.map(item => (
          <div className={'mainDropdownBodyItems dropdownItem' + darkLight} style={bodyStyle} onClick={onChangeX(item)} >
            {item}
          </div>
        ))}
       </div>
      </div>
    </div>
  )
}


function CreateSingleSelect(props){
	var options = props.options;
	var value = props.value;
	var onChange = props.onChange;
	var thisItemRef = props.thisItemRef;
	var onClick = props.onClick;
	var disabled = props.disabled;
	var style = props.style;
	var className = props.className;

	var options1 = [];
	if (options){
		try{
	  	options1 = options.map((anOption, index)=>{
		    return <option key={index} value={anOption}>{anOption}</option>
	  	})
		}catch(err){
			console.log(err);
		}

	}
//
  return <select ref={thisItemRef} value={value} className={className} style={style} disabled={disabled} onClick={onClick} onChange={onChange} >{options1}</select>
//
}

// function CreateMultipleSelect(props){
// 	var options = props.options;
// 	var style = props.style;
// 	var value = props.value;
// 	var disabled = props.disabled;
// 	var onChange = props.onChange;
// 	  var alreadyFoundMatch = false;
// 	var thisItemRef = props.thisItemRef;

// 	  var options1 = options.map((anOption, index)=>{
// 	  	if (anOption === value){
// 	  		alreadyFoundMatch = true;
// 	  	}
// 	    return <option key={index} value={anOption}>{anOption}</option>
// 	  })
// //
//     var deletePiece= <option key='delete' value={'__f_Al_se'}>Delete</option>
// //
//     var toAddPiece;
//     if (!alreadyFoundMatch){
//       toAddPiece = <option key='toAdd' value={value}>Select an Option</option>
//     }
// 	//
// 	  return <select ref={thisItemRef} value={value} style={style} disabled={disabled} onChange={onChange} >{toAddPiece}{options1}{deletePiece}</select>
// 	//
// }

function Input(props){

	var upwardInfo = props.upwardInfo;
	var allStyles = props.allStyles;
	var options = props.options;
	var addClassNamesA = props.addClassNamesA;
	var addClassNamesB = props.addClassNamesB;
	var draggable = props.draggable;
	var onDragStart = props.onDragStart;
	var onDrag = props.onDrag;
	var onDragEnd = props.onDragEnd;
	var parentalType = props.parentalType;
	var onChangeFn = props.onChangeFn;
	var interactionFn = props.interactionFn;
	var currentList = props.currentList;
	var doAScreenRef = props.doAScreenRef;
	var itemPath = props.itemPath;

  const ref1 = useRef();

  useEffect(()=>{
    doAScreenRef(ref1, itemPath);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  StyleFunctions.expandBIU(allStyles);

  var addClassNames =  addClassNamesA + addClassNamesB;
  var className = StyleFunctions.iterateClassNames('form-control' + addClassNames, ['inputSize'], allStyles);

  if (parentalType === 'HFLEX'){
  	if (allStyles.matchHeight){
  		allStyles.height = '100%';
  	}
  }


	var setInputValues = props.setInputValues;
	var idNos = props.idNos;
	var inputValues = props.inputValues;
	var idOut = getFullId(upwardInfo, idNos);
	var onClick = props.onClick;

	// var allStyles = setOfClicksAndStyles.allStyles;
	var inputType = allStyles.inputType;

	function setValue(value){
		if (setInputValues){
	  	inputValues[idOut] = {value, inputType};
      setInputValues({...inputValues});
	  }
	}

	var disabled = allStyles.disabled;

	var allowMultiple = false;
	if (inputType === 'Radio'){
		allowMultiple = allStyles.allowMultiple;
	}

	var origInput;
  var valuePiece = StyleFunctions.getRelevantValueTgt(inputType, allowMultiple);
  origInput = allStyles[valuePiece];
  if (origInput && origInput.e){
  	origInput = '';
  }

  if (inputType === 'Single Select' || inputType === 'Radio'){
  	if (!allowMultiple){
	  	if (options){
		  	if (options && options.length === 0){
		  		origInput = '';
		  	}else{
		  		var haveFound = false;
		  		for (var i = 0; i < options.length; i++){
		  			if (origInput === options[i]){
		  				haveFound = true;
		  				break;
		  			}
		  		}
		  		if (!haveFound){
		  			origInput = options[0];
		  		}		  		
		  	}
	  	}
  	}
  }else if (inputType === 'Integer' || inputType === 'UInteger'){
  	var xxx = allStyles[valuePiece]
  	try{
	  	origInput = xxx.toString();
  	}catch(err){
  		console.log(xxx);
  		console.log(allStyles);
  		console.log(valuePiece);
  	}
  }else if (inputType === 'Decimal'){
  	if (allStyles[valuePiece] || allStyles[valuePiece] === 0){
  		try{
	  		origInput = allStyles[valuePiece].toString();
  		}catch(err){
	  		console.log(allStyles);
	  		console.log(valuePiece);	  			
  		}
  	}else{
  		console.warn('Default decimal value not specified in ' + currentList._g._programName);
  		console.log(allStyles);
  		console.log(valuePiece);
  	}
  }
  
	// const pictureElement = useRef(null);
	var value = ""
	if (setInputValues){
		if (inputValues[idOut]){
			value = inputValues[idOut].value;
		}
	}

	var origInputX = origInput;
	if (allowMultiple){
		origInputX = '';
		if (origInput){
			origInputX = origInput.join(' ');
		}
	}

	useEffect(() => {
		setValue(origInput);
	}, [inputType, origInputX]);

  if (allStyles.dispVis === 'invisible'){
    allStyles.visibility = "hidden";
  }else if (allStyles.dispVis === 'hidden'){
    allStyles.display = 'none';
  }
  
  function postChange(date){
  	setValue(date);
  	onChangeFn(date);
  	// deriveOnClick('onChange', date);
  }

	if (inputType === 'Date' || inputType === 'Date Time'){
		if (inputType === 'Date'){
			return <DatePicker selected={value} className='inputBoxClassLong' dateFormat='dd/MM/yyyy' onChange={postChange} />
		}else{
			return <DatePicker selected={value} showTimeSelect dateFormat='dd/MM/yyyy HH:mm:ss' className='inputBoxClassLong' onSelect={postChange} onChange={postChange}/>
		}
	}


//
	function onChange4(value){
		setValue(value); 
		var valueOut = "\""+value + "\"";
    if (inputType === 'Integer' || inputType === 'UInteger' || inputType === 'Decimal'){
    	if (value === '' || value === '-' || value === '+' || (value === '.' && inputType === 'Decimal')){
    		valueOut = '0';
    	}else if (inputType === 'Integer'){
        var isInt = SharedAcross.isIntegerText(value);
        if (!isInt){
          // window.alert('Only Integers allowed');
          return;
        }
        valueOut = value;
    	}else if (inputType === 'UInteger'){
        var isPInt = SharedAcross.isPositiveIntegerOrZeroText(value);
        if (!isPInt && value !== ''){
          // window.alert('Only Positive Integers or Zero allowed');
          return;
        }
        valueOut = value;
    	}else if (inputType === 'Decimal'){
        var isPDec = SharedAcross.isDecimalText(value);
        if (!isPDec){
          // window.alert('Only Decimals allowed');
          return;
        }
        valueOut = value;
    	}
    }
		onChangeFn(valueOut);

	}
	function onChange3(e){
		var value = e.target.value;
		onChange4(value);
		e.stopPropagation();
	}

	var placeholderEvaluated = allStyles.placeholder;
	if (placeholderEvaluated && placeholderEvaluated.e){
		placeholderEvaluated = '';
	}



	var selectInsides;
	if (inputType === 'Radio'){

		var circleStyle = {};
		if (allStyles.radioShape === 'square'){
			circleStyle.borderRadius = '0%';
		}

		function onChange5(e){
			var valueCopy = value.map((aV, index)=>{
				return aV;
			})
			var haveFound = -1;
			for (var i = 0; i < valueCopy.length; i++){
				if (valueCopy[i] === e.target.value){
					haveFound = +i;
				}					
			}
			if (haveFound > -1){
				valueCopy.splice(haveFound, 1);
			}else{
				valueCopy.push(e.target.value);
			}
			setValue(valueCopy);
	  	onChangeFn(valueCopy);
			e.stopPropagation();
			
		}

		var changeFn = onChange3;
		if (allStyles.allowMultiple){
			changeFn = onChange5;
		}

		var cardPieces = options.map((anOption, index)=>{

			var isChecked = false;
			if (allStyles.allowMultiple){
				for (var ii = 0; ii < value.length; ii++){
					if (value[ii] === anOption){
						isChecked = true;
					}
				}
			}else{
				isChecked = (value === anOption);
			}
			var typeX = 'radio';
			if (allowMultiple){
				typeX = 'checkbox'
			}
      return <div className='row' key={index} >
            <label for={index} className=''>
            <input type={typeX} id={index} name={index} value={anOption} onChange={changeFn} checked={isChecked} />
            <div style = {{borderColor:allStyles.outlineColor}}>
              <div className = 'circle' style={circleStyle}>
                <div style = {{backgroundColor:allStyles.tickColor, color:allStyles.tickColor}} className = 'dot'>
                </div>
              </div>
              <div className='textPart'>{anOption}</div>
            </div>
            </label>
          </div>

		})
		if (options.length === 0 && !interactionFn){
			cardPieces = <p className='card-text'>[No Options Specified]</p>
		}
//
   	var insClassNames = StyleFunctions.iterateClassNames('cuesRadio2 container', ['radioTick'], allStyles);


    selectInsides = <div className={addClassNames} style = {allStyles} onClick={onClick} >
    	<div className={insClassNames}>
        {cardPieces}
        </div></div>
//		

	}else if (inputType === 'Single Select'){
		if (allStyles.selectStyle === 'square'){
		  selectInsides = <Dropdown thisItemRef={ref1} options={options} value={value} onChange={onChange4} onClick={onClick} disabled={disabled} style={allStyles} addClassNames={addClassNames}/>

		}else{
		  selectInsides = <CreateSingleSelect thisItemRef={ref1} options={options} value={value} onChange={onChange3} onClick={onClick} disabled={disabled} style={allStyles} className={addClassNames}/>

		}
	//
	// }else if (inputType === 'Multiple Select'){
	  
	//   var pieces = [];
	//   if (value){
	// 		pieces = value.map((aValue, index3)=>{

	// 			function onChangeHere(e){
	// 				var newValue = e.target.value;
	// 				if (newValue === '__f_Al_se'){
	// 					value.splice(+index3, 1);
	// 				}else{
	// 					value[index3] = newValue;
	// 				}
	// 				var v = value.map((aV, index)=>{return aV});
	// 				postChange(v);
	// 			}

	// 			return <CreateMultipleSelect thisItemRef={ref1} key={index3} options={options} value={aValue} disabled={disabled} onChange={onChangeHere} />
	// 		})
	// 	}

 //    function addOptionToMultiple(){
 //    	if (options.length > 0){
 //      	value.push(options[0]);
 //    	}else{
 //    		value.push("");
 //    	}
	// 		var v = value.map((aV, index)=>{return aV});
 //    	postChange(v);
 //    }

	//   selectInsides = <div>{pieces}<button key='add' onClick={addOptionToMultiple}>Add</button></div>
//	  
	}else if (inputType === 'Long Text'){
	  var numRows = 8;
	  if (allStyles.numRows){
	    numRows = allStyles.numRows;
	  }
	  selectInsides = <textarea ref={ref1} rows={numRows} type='text' value={value} placeholder={placeholderEvaluated} className={className} autoComplete='none' style={allStyles} disabled={disabled} onChange={onChange3} onClick={onClick} draggable={draggable} onDragStart={onDragStart} onDrag={onDrag} onDragEnd={onDragEnd}/>
	}else{
    function onKeyDown(e){
      if (e.keyCode === 13){
        if (inputType === 'Integer'){
          var isInt = SharedAcross.isIntegerText(value);
          if (!isInt){
            window.alert('Only Integers allowed');
            return;
          }
        }else if (inputType === 'UInteger'){
          var isPInt = SharedAcross.isPositiveIntegerOrZeroText(value);
          if (!isPInt){
            window.alert('Only Positive Integers or Zero allowed');
            return;
          }
        }else if (inputType === 'Decimal'){
          var isPDec = SharedAcross.isDecimalText(value);
          if (!isPDec){
            window.alert('Only Decimals allowed');
            return;
          }
        }
        // deriveOnClick('onEnter', val);
      }
    }

    // function onMouseOver(e){
	   //  if (disabled && !interactionFn){
	   //  	onClick(e);
	   //  }
	   //  e.preventDefault();
    // }

	  var className1 = StyleFunctions.iterateClassNames('form-control ' + addClassNamesB, ['inputSize', 'tooltipShade'], allStyles);

    var dataToolTip = null;
    var toolTipLocation = false;

    if (allStyles.tooltipSet){
      dataToolTip = allStyles.toolText;
      toolTipLocation = allStyles.tooltipLocation;
    }

    var errorMessaging = null;
    var errorMessagingPieces = [];
    if (inputType === 'UInteger'){
      var isUInt = SharedAcross.isPositiveIntegerOrZeroText(value);
      if (isUInt){
	    	if (allStyles.gotMinVal){
	    		var minUInt = allStyles.minValUInteger;
	    		if (minUInt && minUInt > (BigInt(value))){
	    			errorMessagingPieces.push(allStyles.minValErrorText);
//
	    		}
	    	}
	    	if (!errorMessaging && allStyles.gotMaxVal){
	    		var maxUInt = allStyles.maxValUInteger;
	    		if (maxUInt && maxUInt < (BigInt(value))){
	    			errorMessagingPieces.push(allStyles.maxValErrorText);
//
	    		}
	    	}

      }else if (value){
      	errorMessagingPieces.push('Need a positive integer or zero');
      }

    }else if (inputType === 'Integer'){
      var isInt = SharedAcross.isIntegerText(value);
      if (isInt){
	    	if (allStyles.gotMinVal){
	    		var minInt = allStyles.minValInteger;
	    		if (minInt && minInt > BigInt(value)){
	    			errorMessagingPieces.push(allStyles.minValErrorText);
//
	    		}
	    	}
	    	if (!errorMessaging && allStyles.gotMaxVal){
	    		var maxInt = allStyles.maxValInteger;
	    		if (maxInt && maxInt < BigInt(value)){
	    			errorMessagingPieces.push(allStyles.maxValErrorText);
//
	    		}
	    	}

      }else if (value){
      	errorMessagingPieces.push('Need an integer');
      }

    }else if (inputType === 'Decimal'){
      var isPDec = SharedAcross.isDecimalText(value);
      if (isPDec){
	    	if (allStyles.gotMinVal){
	    		var minDec = allStyles.minValDecimal;
	    		if (minDec > +value){
	    			errorMessagingPieces.push(allStyles.minValErrorText);
//
	    		}
	    	}
	    	if (!errorMessaging && allStyles.gotMaxVal){
	    		var maxDec = allStyles.maxValDecimal;
	    		if (maxDec < +value){
	    			errorMessagingPieces.push(allStyles.maxValErrorText);
//
	    		}
	    	}
      }else if (value){
      	errorMessagingPieces.push('Need a decimal');
      }
    }

    if (errorMessagingPieces.length > 0){
    	// errorMessaging = <span style={{color:'red'}}>{errorMessagingPieces.join(', ')}</span>
    	errorMessaging = <center><p style={{color:'red'}}>{errorMessagingPieces.join(', ')}</p></center>
    }

	  selectInsides = <div className={addClassNamesA + ' px-0'} onClick={onClick} draggable={draggable} onDragStart={onDragStart} onDrag={onDrag} onDragEnd={onDragEnd} data-tooltip={dataToolTip} data-tooltip-location={toolTipLocation}><input className={className1} ref={ref1} type='text' value={value} onChange={onChange3} placeholder={placeholderEvaluated} style={{...allStyles, ...{width:'100%'}}} autoComplete='none' onKeyDown={onKeyDown} readOnly={disabled}  />{errorMessaging}</div>
//	  
	  // selectInsides = <input ref={thisItemRef} type='text' value={value} onChange={onChange3} placeholder={placeholderEvaluated} style={allStyles} className={className}  autoComplete='none' onKeyDown={onKeyDown} onClick={onClick} draggable={draggable} onDragStart={onDragStart} onDrag={onDrag} onDragEnd={onDragEnd} readOnly={disabled}/>
	}

	return selectInsides;

//
} 

function getFullId(upwardInfo, idNos){
    if (upwardInfo){
         var filteredUpwardInfo = upwardInfo.filter((aU, index)=>{return aU.t.indexOf("gV_") === 0}).map((aU, index)=>{
            return CoreFns.convertToStrings(aU.v, aU.type);});
         return idNos + "_" + filteredUpwardInfo.join("_");        
    }else{
        return "x";
    }

}

export default Input;
